import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardProductCode } from '../../constants/Card';

type Props = {
  cardInfo: CardInfo;
  hasButton?: boolean;
};

const CardContainerContent: React.FC<Props> = ({ cardInfo, hasButton = false }) => {
  const { t } = useTranslation();

  const { cardProductCode, cashYn } = cardInfo;
  const cashable: boolean = cashYn?.toUpperCase() === 'Y';

  const defaultJSX = (
    <dl className={`content1 ${hasButton ? "content-with-button" : ""}`.trim()}>
      <dd>{t(`STAT01.benefit01.${cardProductCode}_A`)}</dd>
      <dd>{t(`STAT01.benefit02.${cardProductCode}_A`)}</dd>
      <dd>{t(`STAT01.benefit03.${cardProductCode}_A`)}</dd>
    </dl>
  );

  switch (Number(cardProductCode)) {
    case CardProductCode.PremierCard:
    case CardProductCode.DreamCard:
      return cashable ? (
        <dl className={`content-atm ${hasButton ? "content-with-button" : ""}`.trim()}>
          <dd style={{ color: '#000AFF' }}>{t(`STAT01.benefit00-1.${cardProductCode}`)}<br />{t(`STAT01.benefit00-2.${cardProductCode}`)}</dd>
          <dd>{t(`STAT01.benefit01.${cardProductCode}`)}</dd>
          <ul>
            <li>{t(`STAT01.benefit01-1.${cardProductCode}`)}</li>
            <li>{t(`STAT01.benefit01-2.${cardProductCode}`)}</li>
            <li>{t(`STAT01.benefit01-3.${cardProductCode}`)}</li>
          </ul>
        </dl>
      ) : defaultJSX;
    case CardProductCode.WelcomeCard:
      return cashable ? (
        <dl className={`content-atm ${hasButton ? "content-with-button" : ""}`.trim()}>
          <dd style={{ color: '#000AFF' }}>{t(`STAT01.benefit00-1.${cardProductCode}`)}<br/>{t(`STAT01.benefit00-2.${cardProductCode}`)}</dd>
          <dd>{t(`STAT01.benefit01.${cardProductCode}`)}</dd>
        </dl>
      ) : defaultJSX;
    case CardProductCode.QuickCard:
      return (
        <dl className={`content-atm ${hasButton ? "content-with-button" : ""}`.trim()}>
          <dd style={{ color: '#000AFF' }}>{t(`STAT01.benefit00-1.${cardProductCode}`)}<br />{t(`STAT01.benefit00-2.${cardProductCode}`)}</dd>
          <dd>{t(`STAT01.benefit01.${cardProductCode}`)}</dd>
        </dl>
      );
    default:
      return defaultJSX;
  }
};

export default CardContainerContent;
